/* eslint-disable */
import UserService from '@/services/UserService';
import {
  VuexModule,
  Module,
  Action,
  Mutation,
} from 'vuex-module-decorators';
import moment from 'moment';
import Pusher from 'pusher-js';

const userService = new UserService();

@Module({ namespaced: true })
export default class Profile extends VuexModule {
  public balance: number = 0;

  public bank: string = '';

  public accountNumber: string = '';

  public accountName: string = '';

  public username: string = '';

  public ufaUsername: string = '';

  public refCode: string = '';

  public affiliateRevenue: number = 0;

  public totalDeposit: number = 0;

  public totalWithdraw: number = 0;

  public lastWeekTotalDeposit: number = 0;

  public lastWeekTotalWithdraw: number = 0;

  @Mutation
  public setbank(payload: {
    bank: string;
    account_number: string;
    account_name: string;
  }) {
    this.bank = payload.bank;
    this.accountNumber = payload.account_number;
    this.accountName = payload.account_name;
  }

  @Mutation
  public setUfaUsername(payload: string) {
    this.ufaUsername = payload;
  }

  @Mutation
  public setUsername(payload: string) {
    this.username = payload;
  } 

  @Mutation
  public setRefCode(payload: string) {
    this.refCode = payload;
  }

  @Mutation
  public setaffiliateRevenue(payload: number) {
    this.affiliateRevenue = payload;
  }

  @Mutation
  public setBalance(payload: number) {
    this.balance = payload;
  }

  @Mutation
  public setStats(payload: { deposit: number; withdraw: number; lastWeekTotalDeposit: number; lastWeekTotalWithdraw: number; }) {
    this.totalDeposit = payload.deposit;
    this.totalWithdraw = payload.withdraw;
    this.lastWeekTotalDeposit = payload.lastWeekTotalDeposit;
    this.lastWeekTotalWithdraw = payload.lastWeekTotalWithdraw;
  }

  @Action({rawError: true})
  public async getProfile() {
    const { data } = await userService.getProfile();
    const today = moment();
    const currentWeek = today.format('ww-YYYY');
    let lastWeek = moment().subtract(1, 'week').format('ww-YYYY')
    const currentYear = moment().format('YYYY');
    if (lastWeek.split('-')[1] !== currentYear) {
      lastWeek = `${lastWeek.split('-')[0]}-${currentYear}`;
    }
    this.context.commit('setbank', {
      bank: data.user.bank,
      account_number: data.user.account_number,
      account_name: data.user.account_name,
    });
    this.context.commit('setStats', {
      deposit: data.stat?.deposit_log[currentWeek] || 0,
      withdraw: data.stat?.withdraw_log[currentWeek] || 0,
      lastWeekTotalDeposit: data.stat.deposit_log[lastWeek] || 0,
      lastWeekTotalWithdraw: data.stat.withdraw_log[lastWeek] || 0,
    });
    this.context.commit('setUsername', data.user.username);
    this.context.commit('setaffiliateRevenue', data.affiliate_revenue);
    this.context.commit('setRefCode', data.user.ref_code);
    this.context.commit('setUfaUsername', data.user.agent_api_username);
    const pusher = new Pusher('c2756f0d9309919e42f6', { cluster: 'ap1' });
    const channel = pusher.subscribe('request-accept');
    console.log(`request-accept-${this.username}`);
    channel.bind(`request-accept-${this.username}`, async (data: any) => {
      this.context.commit('Snackbar/showNotification', { message: 'ยอดเติมเงินได้รับงานอนุมัติแล้ว', error: false }, { root: true });
      this.context.dispatch('Dialog/updateDialog', { open: false, dialogType: 'DepositDialog' }, { root: true });
      await this.context.dispatch('fetchBalance');
    });
  }

  @Action
  public async fetchBalance() {
    const { data } = await userService.checkBalance();
    this.context.commit('setBalance', Number(data.result));
  }
}
